import { useState } from "react"
import {
  Button,
  Flex,
  Form,
  FormProps,
  Input,
  Radio,
  Row,
  Typography,
} from "antd"
import { useForm } from "antd/es/form/Form"

type Props = Pick<FormProps, "form" | "onFinish"> & {
  isLoading: boolean
}
export const RefundInnerForm = ({
  form = useForm()[0],
  isLoading,
  onFinish,
}: Props) => {
  const [isDisabled, setDisabledSubmit] = useState(false)
  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length)
    const { address, fee_payer } = form.getFieldsValue()
    const isValid = Boolean(address) && Boolean(fee_payer)
    setDisabledSubmit(hasErrors || !isValid)
  }

  return (
    <Form
      form={form}
      id="GENERATED_ID_REFUNDINNERFORM_FORM_VOID_1"
      layout="vertical"
      name="RefundPaymentsForm"
      onChange={handleFormChange}
      onFinish={onFinish}
      size="large"
    >
      <Flex gap={32} vertical>
        <Form.Item
          id="GENERATED_ID_REFUNDINNERFORM_FORM_ITEM_VOID_1"
          label="Address"
          name="address"
          rules={[
            {
              message: "Please input address for refund",
              required: true,
            },
          ]}
          style={{ margin: 0 }}
        >
          <Input />
        </Form.Item>
        <Flex align="center" gap={16}>
          <Typography.Paragraph style={{ fontSize: "16px", margin: 0 }}>
            Who pays the blockchain network fee
          </Typography.Paragraph>
          <Form.Item
            id="GENERATED_ID_REFUNDINNERFORM_FORM_ITEM_VOID_2"
            initialValue="merchant"
            name="fee_payer"
            rules={[
              {
                message: "Please select transfer method",
                required: true,
              },
            ]}
            style={{ margin: 0 }}
          >
            <Radio.Group buttonStyle="solid" size="small">
              <Radio.Button value="merchant">Merchant</Radio.Button>
              <Radio.Button value="customer">Customer</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Flex>

        <Row justify="center" style={{ margin: 0 }}>
          <Button
            disabled={isDisabled}
            htmlType="submit"
            id="GENERATED_ID_REFUNDINNERFORM_BUTTON_CONFIRM_1"
            loading={isLoading}
            size="large"
            type="primary"
          >
            Confirm
          </Button>
        </Row>
      </Flex>
    </Form>
  )
}
